import { InterestRate } from '../api/httpHandlers'

// STATE

type CalculationState = 'ok' | 'low' | 'high'

export interface AppState {
  interestRateObjs: InterestRate[]
  placementAmount: number
  interestRateIndex: number
  hasAppError: boolean
  calculationState: CalculationState
  userIsTyping: boolean
}

// STATE MANAGEMENT

interface InterestRateIndexChangeAction {
  type: 'interestRateIndexChange'
  value: number
}

interface DataFetchedAction {
  type: 'appDataFetched'
  interestRateObjs: InterestRate[]
  placementAmount: number
}

interface TypingAction {
  type: 'typing'
  value: boolean
}

interface CalculationStateChangeAction {
  type: 'calculationStateChange'
  value: CalculationState
}

interface ErrorAction {
  type: 'error'
}

export type AppAction =
  | DataFetchedAction
  | InterestRateIndexChangeAction
  | TypingAction
  | CalculationStateChangeAction
  | ErrorAction

export function fixedAppReducer(state: AppState, action: AppAction): AppState {
  const mode = import.meta.env.MODE
  if (mode !== 'production') console.log(`State change: ${action.type}`)
  switch (action.type) {
    case 'appDataFetched': {
      const { placementAmount, interestRateObjs } = action
      let interestRateIndex = state.interestRateIndex
      if (interestRateIndex >= interestRateObjs.length)
        interestRateIndex = interestRateObjs.length - 1
      return {
        ...state,
        interestRateIndex,
        userIsTyping: false,
        calculationState: 'ok',
        interestRateObjs,
        placementAmount,
      }
    }
    case 'typing': {
      return {
        ...state,
        userIsTyping: action.value,
      }
    }
    case 'interestRateIndexChange': {
      const value = action.value
      const newMinAmount = state.interestRateObjs[value].minAmount
      const newMaxAmount = state.interestRateObjs[value].maxAmount
      let calculationState: CalculationState = 'ok'
      if (state.placementAmount < newMinAmount) calculationState = 'low'
      if (state.placementAmount > newMaxAmount) calculationState = 'high'

      return {
        ...state,
        calculationState,
        interestRateIndex: value,
      }
    }
    case 'calculationStateChange': {
      return {
        ...state,
        calculationState: action.value,
      }
    }
    case 'error': {
      return {
        ...state,
        hasAppError: true,
      }
    }
    default: {
      if (mode !== 'production') console.error('Unknown action: ' + action)
      return {
        ...state,
        hasAppError: true,
      }
    }
  }
}
